import React, { useState } from "react";
import { Link } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-8">
                    <div style={{ paddingLeft: "10%", paddingTop: "10px", paddingBottom: "10px" }}>
                        <div style={{ float: 'left', width: '80px' }}>
                            <img src="./images/devi-logo.png" style={{ width: "100%" }} alt="logo" />
                        </div>
                        <div style={{ float: 'left', paddingTop: '20px' }}>
                            <span className="templename">
                                Valayanad Devi Temple
                            </span>
                            {/* <span className="makreri-templename">
                               Sree Makreri Temple
                            </span> */}
                        </div>


                    </div>
                </div>

                {/* HAMBURGER BUTTON (Mobile only) */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU ITEMS */}
                {/* MENU ITEMS */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Home
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                History
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.valayanaddevi.in/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Darsan Time
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Administration
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Gallery
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Contact
                            </Link>
                        </div>

                    </div>
                </div>
            </div>
            <div style={{width:'150px',height:'150px',position:'fixed',bottom:'0',right:'0',marginRight:'50px',marginBottom:'180px'}}>
               <a href="https://booking.valayanaddevi.in/"> <img src="./images/online-booking.png" alt="Online Booking" style={{width:'100%',border:'4px solid white',borderRadius:'10px'}} /></a>
            </div>
        </div>
    );
}

export default MainMenu;
